import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'

import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'

export class SearchspringSuggest extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/suggest/query'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { query } = options

    this.params.set('language', 'en')
    this.params.set('suggestionCount', 5)
    this.params.set('productCount', 6)

    if (query) this.params.set('q', query)

    super.updateParams()
  }
}

export const SearchspringSuggestProvider = generateSearchspringProvider(SearchspringSuggest, (results) => {
  return {
    ...results,
    items: results.alternatives.map((alternative) => ({
      query: alternative.text,
      label: alternative.text
    }))
  }
})
